import * as React from 'react';
import { Box, Button } from '@drone-js/core';
import { useCalendarHeader } from './useCalendarHeader.js';

var CalendarHeader = function CalendarHeader(props) {
  var prevButton = props.prevButton,
    nextButton = props.nextButton,
    onKeyDown = props.onKeyDown;
  var _useCalendarHeader = useCalendarHeader(),
    prevButtonRef = _useCalendarHeader.prevButtonRef,
    nextButtonRef = _useCalendarHeader.nextButtonRef,
    buttonSize = _useCalendarHeader.buttonSize;
  return /*#__PURE__*/React.createElement(Box, {
    p: "8",
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    id: "calendar-header"
  }, prevButton ? /*#__PURE__*/React.createElement(Box, buttonSize, /*#__PURE__*/React.createElement(Button, {
    id: "previous-month-nav",
    variant: "icon",
    hierarchy: "tertiary",
    size: "m",
    "aria-label": prevButton['aria-label'],
    onClick: prevButton.onClick,
    leadingIcon: prevButton.icon,
    state: prevButton.disabled ? 'disabled' : undefined,
    ref: prevButtonRef,
    onKeyDown: onKeyDown
  })) : /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Box, buttonSize)), /*#__PURE__*/React.createElement(Box, {
    "aria-live": "polite",
    role: "presentation",
    display: "flex",
    width: "100%",
    justifyContent: "center"
  }, props.children), nextButton ? /*#__PURE__*/React.createElement(Box, buttonSize, /*#__PURE__*/React.createElement(Button, {
    id: "next-month-nav",
    variant: "icon",
    hierarchy: "tertiary",
    size: "m",
    "aria-label": nextButton['aria-label'],
    onClick: nextButton.onClick,
    leadingIcon: nextButton.icon,
    state: nextButton.disabled ? 'disabled' : undefined,
    ref: nextButtonRef,
    onKeyDown: onKeyDown
  })) : /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Box, buttonSize)));
};

export { CalendarHeader };
//# sourceMappingURL=CalendarHeader.js.map
